/**
 * Analytics tracker - sends page views and events to the backend.
 * Includes session tracking, browser info, and fire-and-forget delivery.
 * All calls are silent; analytics never breaks the app experience.
 */

// ---------------------------------------------------------------------------
// Session management — one session per browser tab/visit
// ---------------------------------------------------------------------------
function getSessionId() {
  let sid = sessionStorage.getItem('dex_session_id');
  if (!sid) {
    sid = `s_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    sessionStorage.setItem('dex_session_id', sid);
  }
  return sid;
}

// ---------------------------------------------------------------------------
// Core send function
// ---------------------------------------------------------------------------
async function send(payload) {
  try {
    await fetch('/api/analytics/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...payload,
        sessionId: getSessionId(),
      }),
    });
  } catch (_) {
    // Silent fail — analytics must never disrupt the user
  }
}

// ---------------------------------------------------------------------------
// Track a page view
// ---------------------------------------------------------------------------
export function trackPageView(path) {
  send({
    type: 'pageview',
    path,
    userAgent: navigator.userAgent,
    referrer: document.referrer || '',
    language: navigator.language || 'es',
    screenWidth: window.screen.width,
  });
}

// ---------------------------------------------------------------------------
// Track a custom event with optional extra data
// ---------------------------------------------------------------------------
export function trackEvent(name, data = {}) {
  send({
    type: 'event',
    name,
    path: window.location.pathname,
    userAgent: navigator.userAgent,
    language: navigator.language || 'es',
    screenWidth: window.screen.width,
    data,
  });
}
